var pe = pe || {};
pe.subscricoes = pe.subscricoes || {};
pe.subscricoes.labels = {
    required: "Campo de preenchimento obrigatório.",
    invalidEmail: "Endereço de e-mail inválido."
};

$(document).ready(function () {

    //FORM REGISTO SUBSCRIÇÕES
    if ($(".subscribe-container").length)
    {

        $(".subscribe-container").each(function() {

            $(this).validate({
                errorPlacement: function(error, element) {
                    error.insertAfter(element.closest("div"))
                }
            });

            //$(".subscribe-container").find("#email").rules( "add", {
            $(this).find("input[name=email]").rules( "add", {
                required: true,
                messages: {
                   required:  pe.subscricoes.labels.required
                }
            });
            
        });

        $(".subscribe-container .submit-subscribe").click(function(event){
            var form = $(this).parents("form");
            var isValidForm = form.valid();
            if (!isValidForm) {
                return false;
            }
            form.find("input[name=action]").val("S");
        });

        $(".subscribe-container .submit-remove").click(function(event){
            var form = $(this).parents("form");            
            var isValidForm = form.valid();
            if (!isValidForm) {
                return false;
            }
            form.find("input[name=action]").val("U");
        });

        $(".subscribe-container").keypress(function(e) {
            if (e.keyCode == 13) {
                var form = $(this);
                var isValidForm = form.valid();
                if (!isValidForm) {
                    return false;
                }
                form.find("input[name=action]").val("S");
            }
        });
		
        $('.subscribe-container').on('ajax-form-submit:done', function(e, data, textStatus, jqXHR){
            var _this = $(this);
            _this.fadeOut('slow');
            if (data) {
                if (data == 'OK') {
                    _this.closest('span').find('.subscribe-generic-error').hide();                    
                    _this.closest('span').find('.subscribe-generic-success').fadeIn('slow');
                }
                else {  //já existe (subscrição)/não existe (remoção)
                    _this.closest('span').find('.subscribe-generic-error').hide();                    
                    _this.closest('span').find('.subscribe-generic-success').hide();                    
                    if (_this.find("input[name=action]").val() == 'S') {   //subscrever
                        _this.closest('span').find('.subscribe-generic-userexists').fadeIn('slow');
                    }
                    else {  //remover
                        _this.closest('span').find('.subscribe-generic-usernotexists').fadeIn('slow');
                    }
                }
            }
            else {
                _this.closest('span').find('.subscribe-generic-error').fadeIn('slow');
                _this.closest('span').find('.subscribe-generic-success').hide();
            }
            setTimeout(function(){
                _this.closest('span').find('.subscribe-generic-success').fadeOut(0);                    
                _this.closest('span').find('.subscribe-generic-error').fadeOut(0);                
                _this.closest('span').find('.subscribe-generic-userexists').fadeOut(0);
                _this.closest('span').find('.subscribe-generic-usernotexists').fadeOut(0);
            }, 3000);
        });

        $('.subscribe-container').on('ajax-form-submit:fail', function(e, jqXHR, textStatus, errorThrown){
            $(this).fadeOut('slow');
            $(this).closest('span').find('.subscribe-generic-error').fadeIn('slow');
            $(this).closest('span').find('.subscribe-generic-success').hide();
        });
    
    }
    
});


